var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Star Empty",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.585 13.856"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10328",
    d: "M7.293 0l2.279 4.558 5.014.729-3.647 3.555.82 5.014-4.467-2.37-4.467 2.37.82-5.014L0 5.287l5.014-.729z"
  })));
}

export default SvgStar;